module.exports = __webpack_public_path__ + "img/millenium.cf965f92.jpg";